import { HotkeyBadge } from 'components/HotkeyBadge';
import { classes } from 'utils/style';
import styles from './HotkeyNav.module.css';

/**
 * A navigation component for category/tab selection with hotkey support.
 * Displays a row of buttons with optional hotkey badges.
 *
 * @param {Array<{id: string, label: string, hotkey?: string}>} items - Navigation items
 * @param {string} activeId - Currently active item ID
 * @param {(id: string) => void} onSelect - Callback when an item is selected
 * @param {boolean} showHotkeys - Whether to display hotkey badges (default: true)
 * @param {string} className - Additional CSS class for the nav element
 */
export const HotkeyNav = ({
  items,
  activeId,
  onSelect,
  showHotkeys = true,
  className,
}) => {
  return (
    <nav className={classes(styles.nav, className)}>
      {items.map(({ id, label, hotkey }) => (
        <button
          key={id}
          type="button"
          className={styles.navItem}
          data-active={id === activeId}
          aria-current={id === activeId ? 'true' : undefined}
          onClick={() => onSelect(id)}
        >
          {label}
          {showHotkeys && hotkey && (
            <HotkeyBadge className={styles.hotkey}>{hotkey}</HotkeyBadge>
          )}
        </button>
      ))}
    </nav>
  );
};
